export default __webpack_public_path__ + "static/media/account-circle.74e2e92f.svg";